import { api } from './api'

export type Channel = 'redux' | 'incoming'

export const messagesApi = api.injectEndpoints({
    endpoints: (build) => ({
        getMessages: build.query<any, string>({
            query: (companyId: string) => `messages/company/${companyId}`,
        }),
    }),
});

export const { useGetMessagesQuery } = messagesApi;